import React from 'react';
import styles from '../AiDialog.module.css';
import ChatGPTStyleMessage from '../../../ChatGptTypingMsg/ChatGPTStyleMessage';

export function SuggestionsArea({
  isLoading,
  chatResponseText,
  chatSuggestions,
  selectedValue,
  onChooseSuggestion,
}) {
  if (!isLoading && !chatResponseText) return null;

  return (
    <div className={styles.suggestionsRoot}>
      <ChatGPTStyleMessage
        text={chatResponseText}
        isLoading={isLoading}
        suggestions={chatSuggestions}
        selectedValue={selectedValue}
        onSelectSuggestion={onChooseSuggestion}
      />
    </div>
  );
}
